import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.scrollToBottom()
  }

  scrollToBottom() {
    this.element.scrollTop = this.element.scrollHeight
  }

  // Use this if you want to scroll when new elements are added
  // (requires MutationObserver or similar, or just a custom event)
  onMutation() {
    this.scrollToBottom()
  }
}
